// @flow

import React from "react";

const ChatroomPlaceholder = () => (
  <svg
    width="792"
    height="360"
    viewBox="0 0 792 360"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M84 37H70C65.5817 37 62 40.5817 62 45V59C62 63.4183 65.5817 67 70 67H84C88.4183 67 92 63.4183 92 59V45C92 40.5817 88.4183 37 84 37Z"
      fill="#D0D5DD"
    />
    <path
      d="M84 260H70C65.5817 260 62 263.582 62 268V282C62 286.418 65.5817 290 70 290H84C88.4183 290 92 286.418 92 282V268C92 263.582 88.4183 260 84 260Z"
      fill="#D0D5DD"
    />
    <path
      d="M84 115H70C65.5817 115 62 118.582 62 123V137C62 141.418 65.5817 145 70 145H84C88.4183 145 92 141.418 92 137V123C92 118.582 88.4183 115 84 115Z"
      fill="#D0D5DD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M116 37H99C102.17 39.703 106.825 45.514 109 49.703V97C109 101.418 112.582 105 117 105H297C301.418 105 305 101.418 305 97V45C305 40.582 301.418 37 297 37H117C116.654 37 116.313 37.022 115.979 37.065C115.986 37.043 115.993 37.021 116 37Z"
      fill="#D0D5DD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M116 260H99C102.17 262.703 106.825 268.514 109 272.703V316C109 320.418 112.582 324 117 324H297C301.418 324 305 320.418 305 316V268C305 263.582 301.418 260 297 260H117C116.654 260 116.313 260.022 115.979 260.065C115.986 260.043 115.993 260.021 116 260Z"
      fill="#D0D5DD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M116 115H99C102.17 116.908 106.825 121.01 109 123.966V155C109 159.418 112.582 163 117 163H272C276.418 163 280 159.418 280 155V123C280 118.582 276.418 115 272 115H117C116.651 115 116.307 115.022 115.969 115.066C115.98 115.044 115.99 115.022 116 115ZM109 181C109 176.582 112.582 173 117 173H440C444.418 173 448 176.582 448 181V241C448 245.418 444.418 249 440 249H117C112.582 249 109 245.418 109 241V181Z"
      fill="#D0D5DD"
    />
    <path
      d="M726 37H541C538.791 37 537 38.7909 537 41V63C537 65.2091 538.791 67 541 67H726C728.209 67 730 65.2091 730 63V41C730 38.7909 728.209 37 726 37Z"
      fill="#D0D5DD"
    />
    <path
      d="M726 167H541C538.791 167 537 168.791 537 171V193C537 195.209 538.791 197 541 197H726C728.209 197 730 195.209 730 193V171C730 168.791 728.209 167 726 167Z"
      fill="#D0D5DD"
    />
    <path
      d="M726 256H541C538.791 256 537 257.791 537 260V282C537 284.209 538.791 286 541 286H726C728.209 286 730 284.209 730 282V260C730 257.791 728.209 256 726 256Z"
      fill="#D0D5DD"
    />
    <path
      d="M726 75H541C538.791 75 537 76.7909 537 79V101C537 103.209 538.791 105 541 105H726C728.209 105 730 103.209 730 101V79C730 76.7909 728.209 75 726 75Z"
      fill="#D0D5DD"
    />
    <path
      d="M726 205H541C538.791 205 537 206.791 537 209V231C537 233.209 538.791 235 541 235H726C728.209 235 730 233.209 730 231V209C730 206.791 728.209 205 726 205Z"
      fill="#D0D5DD"
    />
    <path
      d="M726 294H541C538.791 294 537 295.791 537 298V320C537 322.209 538.791 324 541 324H726C728.209 324 730 322.209 730 320V298C730 295.791 728.209 294 726 294Z"
      fill="#D0D5DD"
    />
    <path
      d="M726 113H541C538.791 113 537 114.791 537 117V139C537 141.209 538.791 143 541 143H726C728.209 143 730 141.209 730 139V117C730 114.791 728.209 113 726 113Z"
      fill="#D0D5DD"
    />
  </svg>
);

export default ChatroomPlaceholder;
